import './styles.scss';

import { faX } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, CircularProgress, Modal } from '@mui/material';

interface DeleteApiKeyModalProps {
  open: boolean;
  handleClose: () => void;
  onConfirm: () => void;
  /** Human-readable identifier for the key being deleted (name or client id). */
  apiKeyLabel?: string;
  isLoading?: boolean;
  errorMessage?: string | null;
}

const DeleteApiKeyModal = ({
  open,
  handleClose,
  onConfirm,
  apiKeyLabel,
  isLoading,
  errorMessage,
}: DeleteApiKeyModalProps) => {
  return (
    <Modal open={open} onClose={handleClose} className="delete-api-key-modal-container">
      <div className="delete-api-key-modal-content">
        <div className="header">
          <h1>Delete API key</h1>
          <Button className="close-button" onClick={handleClose}>
            <FontAwesomeIcon icon={faX} />
          </Button>
        </div>

        <div className="subtitle">
          Are you sure you want to delete this key? Any WebSocket sessions using it will stop
          authenticating.
          {apiKeyLabel && (
            <>
              <br />
              <strong>{apiKeyLabel}</strong>
            </>
          )}
        </div>

        {errorMessage && <div className="delete-api-key-error">{errorMessage}</div>}

        <div className="buttons">
          <Button className="cancel-button" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="delete-button" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? <CircularProgress size={24} /> : <span>Delete API key</span>}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteApiKeyModal;
